import { Col, Input } from 'reactstrap'

const RemovedDays = ({ title, value }) => {
  return (
    <fieldset>
      <div className='form-group row align-items-center'>
        <label className='col-md-2 col-form-label'>{title}:</label>
        <Col md={8}>
          <Input
            disabled
            type='number'
            name='days'
            value={value}
            onFocus={(e) => {
              try {
                const el = e && e.target
                if (el && el.addEventListener) el.addEventListener('wheel', (ev) => ev.target && ev.target.blur(), { passive: true })
              } catch (err) {}
            }}
            onBlur={(e) => {
              try {
                const el = e && e.target
                if (el && el.removeEventListener) el.removeEventListener('wheel', (ev) => ev.target && ev.target.blur())
              } catch (err) {}
            }}
          />
          <span className='invalid-feedback'>Fusha është e nevojshme</span>
        </Col>
      </div>
    </fieldset>
  )
}

export default RemovedDays
